import { call, put, select } from "redux-saga/effects";
import { actions as breackDownActions } from "@/reducers/breakdown";
import { checkMocks } from "@/utils/commonUtils";
import { handleSagaError } from '@/sagas/index';

const contextStore = (state) => state.main.context;
const breakdownTrackingStore = (state) => state.breakdown.trackingBreakdown;

export function* getBreakdownTracking({ handlingCode = 0, lastYear }) {
  try {
    const data = { lastYear };
    const context = yield select(contextStore);
    let breakdownTracking = yield select(breakdownTrackingStore);
    if (!breakdownTracking) {
      const getListModule = yield call(() =>
        import("@/adabyron/telcol/fault/get-list")
      );
      const { getList } = getListModule;
      const response = yield call(getList, {
        data,
        context,
      });
      breakdownTracking = response.datos;
    }
    yield put(breackDownActions.successTrackingBreakdown(breakdownTracking));
  } catch (error) {
    const reducerFailureAction =
    breackDownActions.failureTrackingBreakdown(true);
    yield handleSagaError(
      "getBreakdownTracking",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}
